import * as React from 'react';
import type { Equipment } from 'contracts/temperature-control/equipments';
import type { Pagination } from 'contracts/Pagination';
import type { Filters, PaginationControl } from 'hooks/store/temperature-control/use-equipment-search-params';
import { api, handleApiError, applyQueryString } from 'services/api';
import { createSearchParams } from 'pages/TemperatureControl/list-equipments-page/components/equipment-filters/utils'

type ApiResponse = {
  data: Equipment[]
  pagination: Pagination
}

type Payload = {
  filters?: Filters
  pagination?: PaginationControl
}

export const useFetchEquipments = () => {
  const fetchEquipments = React.useCallback(async (payload: Payload) => {
    try {
      const url = applyQueryString('equipments', {
        ...createSearchParams(payload?.filters || {}),
        ...payload?.pagination,
      });
      const { data } = await api.get<ApiResponse>(url);
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { fetchEquipments };
};
